import React, { useState } from 'react';
import { Box, IconButton, Link } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';

import { DropdownFilter } from '../../Planner/Filters/DropdownFilter';
import { useFetchOrgUnitOptions } from './../../../actions/areas/shared/fetchOptions';

const defaultState = { orgUnitId: 0, surname: '' };

export default function MileageCapFilters({ onSubmit }) {
  const [state, setState] = useState(defaultState);
  const { data: options } = useFetchOrgUnitOptions(false);
  const defaultValue = options.lenght > 0 ? options[0].id : 0;

  const handleClear = () => {
    setState(defaultState);
    onSubmit(defaultState);
  };

  return (
    <section className="slick-page-header-section">
      <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box p={1} width={90} textAlign="end">
          <span>Org Unit</span>
        </Box>
        <Box p={1} flexGrow={1}>
          <DropdownFilter
            fullWidth
            data={options}
            defaultValue={defaultValue}
            filterKey={'orgUnit'}
            filterValue={state.orgUnitId}
            onChange={(name, value) => setState({ ...state, orgUnitId: value })}
          />
        </Box>
        <Box p={1} width={90} textAlign="end">
          <span>Surname</span>
        </Box>
        <Box p={1} flexGrow={1}>
          <TextField value={state.surname} fullWidth onChange={e => setState({ ...state, surname: e.target.value })} />
        </Box>
        <Box p={1} width={50} />
        <Box p={1}>
          <Link className="cancel-link" onClick={handleClear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          <IconButton type="submit" size="small" onClick={() => onSubmit(state)} className="search-icon">
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </section>
  );
}
